import { SmartLink } from "@selector/shared/components";
import { type FC } from "react";
import { InfoToggletip } from "widgets";

import { getBlastTargetLinkPath } from "../../../../app-utils/blast.js";
import { type BlastHit } from "../../../../graphql.js";
import {
  ENTITY_TYPE,
  HIT_MISSING_ACCESSION,
  HIT_MISSING_EXT_INDEX,
  HIT_MISSING_INDEX_NOT_IN_SYNC,
} from "../../../../settings/settings.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const HitAccessionCell: FC<IAgGridCellProps> = (props) => {
  const { value, data } = props;
  if (!data) {
    return null;
  }

  // for blast HSPs, extract the hit from the hsp
  const blastHit = data.groupType === ENTITY_TYPE.BLAST_HSP ? data.blastHit : (data as BlastHit);
  const cellValue = blastHit.target && value ? value : blastHit.target ? HIT_MISSING_ACCESSION : HIT_MISSING_ACCESSION;
  const tooltip = !blastHit.target
    ? HIT_MISSING_INDEX_NOT_IN_SYNC
    : !blastHit.target.isExternal
      ? "Go to summary of " + value // TBD: External indices can have an URL to the hit!
      : HIT_MISSING_EXT_INDEX;
  // : "The subject sequence of this hit has no counterpart in the database.";

  return <TableCell>{getLink(blastHit, cellValue, tooltip)}</TableCell>;
};

export function getLink(blastHit: BlastHit, linkText: string, tooltip: string, jobId = -1, queryId = -1) {
  if (linkText == null) {
    return null;
  }

  const linkPath = getBlastTargetLinkPath(blastHit, jobId, queryId);
  if (blastHit.target) {
    const isExternal = blastHit.target.isExternal;
    return (
      <SmartLink to={linkPath} forceExternal={isExternal} tooltip={tooltip} forceTooltip={!!tooltip}>
        {linkText}
      </SmartLink>
    );
  }
  return <TableCell alternativeButton={<InfoToggletip content={tooltip} />}>{linkText}</TableCell>;
}

export default HitAccessionCell;
